export const baseUrl = 'https://cms.emmanuelle-chenais.com'
